module.exports = __webpack_public_path__ + "img/delivery.49cbdb7d.svg";